import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { Box, Label, Popper, Button, Popover, Paragraph, Anchor, Heading } from "@zillow/constellation";
import { useState, useEffect, useRef } from "react";
import { useFormContext } from "react-hook-form";
import { commaSeparateNumber } from "../../utils/zhl-calculator.esm.js";
import TextField from "../Fields/TextField.esm.js";
import { useLastValidDownPaymentValues, FieldConfig } from "./DownPaymentCalculator.utils.esm.js";
const popover = /* @__PURE__ */ jsx(Popover, { header: /* @__PURE__ */ jsx(Heading, { level: "6", children: "Down payment" }), body: /* @__PURE__ */ jsxs(Paragraph, { children: [
  "A",
  " ",
  /* @__PURE__ */ jsx(Anchor, { href: "https://www.zillow.com/learn/down-payment-on-a-house/", children: "down payment" }),
  " ",
  "is the cash payment you make at closing toward the purchase of a home. Most loans require a down payment of at least 3% of the home purchase price. While not required, putting 20% down may help you avoid private mortgage insurance (PMI).",
  " ",
  /* @__PURE__ */ jsx(Anchor, { href: "https://www.zillow.com/learn/private-mortgage-insurance/", children: "Learn more." })
] }) });
const DownPaymentFields = () => {
  const form = useFormContext();
  const {
    setValue,
    getValues
  } = form;
  const lastValidValues = useLastValidDownPaymentValues(form);
  const lastValidPercentageValue = lastValidValues.fields.percentage;
  const percentageHints = [3, 3.5, 5, 10, 20, "Other"];
  const [isOtherSelected, setIsOtherSelected] = useState(function getDefaultOtherSelection() {
    return !percentageHints.includes(Number(lastValidPercentageValue));
  });
  const [, forceRender] = useState({});
  useEffect(() => {
    setTimeout(() => forceRender({}), 100);
  }, []);
  const otherInputRef = useRef(null);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(TextField, { label: "Home price", leftAdornment: "$", name: FieldConfig.homePrice.name, config: FieldConfig.homePrice.config, autoComplete: "off", format: commaSeparateNumber, required: true }),
    /* @__PURE__ */ jsxs(Box, { children: [
      /* @__PURE__ */ jsxs(Box, { sx: {
        display: "flex",
        flexDirection: "row",
        marginBottom: "$spacing.xxs"
      }, children: [
        /* @__PURE__ */ jsx(Label, { children: "Down payment % " }),
        /* @__PURE__ */ jsx(Popper, { style: {
          alignSelf: "center"
        }, triggered: popover })
      ] }),
      /* @__PURE__ */ jsx(Box, { sx: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "start",
        gap: "$spacing.xs",
        marginBottom: "$spacing.sm"
      }, children: percentageHints.map((hint) => {
        const selected = !isOtherSelected && Number(lastValidPercentageValue) === hint || hint === "Other" && isOtherSelected;
        return /* @__PURE__ */ jsx(Box, { as: Button, "aria-selected": selected, size: "sm", type: "button", onClick: function setPercentageFieldValue() {
          if (hint === "Other") {
            setValue("percentage", getValues(FieldConfig.other.name));
            setIsOtherSelected(true);
            setTimeout(() => {
              var _a;
              (_a = otherInputRef.current) == null ? void 0 : _a.focus();
            }, 50);
          } else {
            setIsOtherSelected(false);
            setValue("percentage", hint);
          }
        }, sx: {
          "&&&&": {
            backgroundColor: `${selected ? "$colors.coolGray300" : "$colors.textWhite"}`,
            borderColor: `${selected ? "$colors.black" : "$colors.gray300"}`,
            color: "$colors.backgroundDark",
            borderRadius: "$radii.pill",
            padding: "$spacing.xxs",
            width: "90px"
          }
        }, children: hint === "Other" ? "Other" : hint + "%" }, hint);
      }) })
    ] }),
    /* @__PURE__ */ jsx(Box, { children: isOtherSelected && /* @__PURE__ */ jsx(TextField, { textInputRef: otherInputRef, label: "Other", rightAdornment: "%", name: FieldConfig.other.name, config: FieldConfig.other.config, autoComplete: "off", onChange: () => {
      setValue("percentage", getValues(FieldConfig.other.name));
    } }) })
  ] });
};
export {
  DownPaymentFields as default
};
